import { createContext, useContext } from "react";
import { useComponentRefs } from "./Hooks/useComponentRefs";

const AppContext = createContext();

const AppProvider = ({ children }) => {
  
  const { appRef, routerRef } = useComponentRefs();

  return (
    <AppContext.Provider value={{ 
      appRef,
      routerRef
    }}>
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useAppContext };
